import { render, staticRenderFns } from "./HotlinkHome.vue?vue&type=template&id=53709f5e&"
import script from "./HotlinkHome.vue?vue&type=script&lang=js&"
export * from "./HotlinkHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports